import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent } from '@ionic/angular/standalone';
import { CustomModalController } from '../../shared/services/custom-modal-controller.service';
import { LoginComponent } from '../login/login.component';
import { HeaderModalComponent } from '../shared/header-modal/header-modal.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [
    CommonModule,
    IonContent,
    HeaderModalComponent,
    LoginComponent,
    TranslatePipe
  ],
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent {
  private modalCtrl = inject(CustomModalController);

  onLoginSuccess(): void {
    // Close the modal and return success
    this.modalCtrl.dismiss({ success: true }, 'success');
  }

  onSignupClick(): void {
    // Close the modal when user wants to create account
    this.modalCtrl.dismiss({ success: false }, 'signup');
  }

  onCancel(): void {
    // Close the modal without login
    this.modalCtrl.dismiss({ success: false }, 'cancel');
  }
}
